import React, { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useSelector } from "react-redux";
import {
  FaBed,
  FaUserFriends,
  FaWifi,
  FaDoorOpen,
  FaCheckCircle,
  FaCalendarAlt,
  FaImage,
  FaShieldAlt,
  FaClock,
  FaWhatsapp,
  FaPhoneAlt,
} from "react-icons/fa";
import { resolvePriceFromMap } from "../utils/priceHelper";

const RoomsPage = () => {
  const hotel = useSelector((state) => state.hotel.data) || {};
  const configData = useSelector((state) => state.config?.data);
  const hotelName = hotel?.name || "Ganesh Holiday Homes";
  const hotelPhone = hotel?.phone || "+91 9673150591";
  const cleanPhone = hotelPhone.replace(/[^0-9]/g, "");

  const [activeFilter, setActiveFilter] = useState("all");

  const getPrice = (roomTitle, defaultPrice) => {
    return resolvePriceFromMap(configData?.price_map, roomTitle, defaultPrice);
  };

  const roomsList = [
    {
      id: "standardAC",
      title: "Standard AC Room",
      badge: "❄️ AC Deluxe",
      category: "ac",
      price: getPrice("Standard AC Room", 2300),
      desc: "Cozy air-conditioned room tailored for couples and small families seeking peaceful coastal relaxation after a beach day.",
      image:
        "https://firebasestorage.googleapis.com/v0/b/ganesh-holiday-homes.firebasestorage.app/o/rooms%2FstandardAC%2Froom_Ac_1.jpg?alt=media&token=5ff1f018-4def-4ab8-a438-88840d6f5060",
      maxGuests: 2,
      bed: "1 King Bed",
      size: "220 sq ft",
      amenities: [
        "Split Air Conditioning",
        "Attached Private Bathroom with Geyser",
        "Free High-Speed Wi-Fi",
        "Inverter Power Backup",
        "Fresh Bedding & Towels Provided",
        "Daily Housekeeping on Request",
      ],
      inclusions: "Accommodation stay, free gated parking, 5-min walk to beach.",
    },
    {
      id: "standardNonAC",
      title: "Standard Non-AC Room",
      badge: "🍃 Natural Sea Breeze",
      category: "non-ac",
      price: getPrice("Standard Non-AC Room", 1800),
      desc: "Budget-friendly, naturally airy room with high ceiling fan and cross-ventilation, perfect for budget travelers and nature lovers.",
      image:
        "https://firebasestorage.googleapis.com/v0/b/ganesh-holiday-homes.firebasestorage.app/o/rooms%2FstandardAC%2Froom_2_ac.jpg?alt=media&token=cc127106-6d2a-4ba2-961c-0c954c4adc0a",
      maxGuests: 2,
      bed: "1 King Bed",
      size: "200 sq ft",
      amenities: [
        "High-Speed Ceiling Fan & Ventilation",
        "Attached Private Bathroom with Hot Water",
        "Free High-Speed Wi-Fi",
        "Inverter Power Backup",
        "Fresh Bedding & Clean Towels",
        "Free On-Premise Parking",
      ],
      inclusions: "Accommodation stay, free parking, direct beach proximity.",
    },
    {
      id: "doubleRoomAC",
      title: "Double AC Room",
      badge: "⭐ Family Deluxe AC",
      category: "family",
      price: getPrice("Double AC Room", 3000),
      desc: "Spacious luxury family suite featuring two comfortable double beds, powerful split AC, private sit-out, and abundant room for group get-togethers.",
      image:
        "https://firebasestorage.googleapis.com/v0/b/ganesh-holiday-homes.firebasestorage.app/o/rooms%2FdoubleRoomAC%2FRM5.jpg?alt=media&token=ae1846dc-c7b7-4c60-89d7-7eeb3f258cfd",
      maxGuests: 4,
      bed: "2 Double Beds",
      size: "350 sq ft",
      amenities: [
        "Powerful Split AC System",
        "Spacious Attached Bathroom with 24/7 Hot Water",
        "Balcony / Garden Sit-Out",
        "High-Speed Wi-Fi for Multiple Devices",
        "Inverter Power Backup",
        "Wardrobe & Luggage Space",
      ],
      inclusions: "Spacious accommodation for up to 4 guests, free gated parking, garden access.",
    },
    {
      id: "doubleRoomNonAC",
      title: "Double Non-AC Room",
      badge: "👨‍👩‍👧‍👦 Family Value Suite",
      category: "family",
      price: getPrice("Double Non-AC Room", 2500),
      desc: "Large family room equipped with multiple double beds, wide windows for refreshing coastal sea breeze, and spacious living area.",
      image:
        "https://firebasestorage.googleapis.com/v0/b/ganesh-holiday-homes.firebasestorage.app/o/rooms%2FdoubleRoomNonAC%2Fc0224fc2-45a4-4d63-822d-07fa4c7839ab.jpeg?alt=media&token=91bec3ec-7cc8-4bd1-9a69-faaf61d0a5f2",
      maxGuests: 4,
      bed: "2 Double Beds",
      size: "340 sq ft",
      amenities: [
        "Dual High-Speed Ceiling Fans",
        "Attached Private Bathroom with Hot Water",
        "Private Balcony / Window Sit-Out",
        "Free High-Speed Wi-Fi",
        "Inverter Power Backup",
        "Spacious Room for 4-6 Family Members",
      ],
      inclusions: "Family accommodation, free parking, 5-min walk to Shrivardhan beach.",
    },
  ];

  const filteredRooms = roomsList.filter((room) => {
    if (activeFilter === "all") return true;
    if (activeFilter === "ac") return room.category === "ac" || room.title.includes("AC");
    if (activeFilter === "non-ac") return room.category === "non-ac" || room.title.includes("Non-AC");
    if (activeFilter === "family") return room.category === "family" || room.maxGuests >= 4;
    return true;
  });

  return (
    <div className="d-flex flex-column min-vh-100 bg-light">
      <Navbar />

      {/* Top Banner */}
      <div
        style={{
          background: "linear-gradient(135deg, #07101e 0%, #0b192c 50%, #1e3e62 100%)",
          color: "#ffffff",
          padding: "50px 0 60px 0",
          borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
        }}
      >
        <div className="container text-center">
          <div className="d-inline-flex align-items-center gap-2 bg-white bg-opacity-10 text-white px-3 py-1 rounded-pill small fw-semibold mb-3 border border-white border-opacity-15">
            <span>🏨 Direct Short-Term Accommodation • Shrivardhan, Maharashtra</span>
          </div>
          <h1 className="h1 fw-bold mb-2 font-heading text-white" style={{ fontSize: "2.5rem" }}>
            Our Rooms & Nightly Tariffs
          </h1>
          <p className="text-white-50 mb-0 mx-auto" style={{ maxWidth: "750px", fontSize: "1.05rem" }}>
            Clean, comfortable, and family-friendly rooms just 500 meters from Shrivardhan Beach. Direct booking with instant reservation confirmation in <strong>₹ (INR)</strong>.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <main className="container flex-grow-1 py-5">
        {/* Info Badges Bar */}
        <div className="row g-3 mb-5">
          <div className="col-12 col-md-4">
            <div className="p-3 bg-white rounded-4 shadow-sm border d-flex align-items-center gap-3 h-100">
              <div className="bg-danger bg-opacity-10 text-danger p-3 rounded-circle fs-4 flex-shrink-0">
                <FaClock />
              </div>
              <div>
                <strong className="d-block text-dark">Check-in & Check-out</strong>
                <span className="small text-muted">Check-in: 12:00 PM • Check-out: 11:00 AM</span>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div className="p-3 bg-white rounded-4 shadow-sm border d-flex align-items-center gap-3 h-100">
              <div className="bg-success bg-opacity-10 text-success p-3 rounded-circle fs-4 flex-shrink-0">
                <FaShieldAlt />
              </div>
              <div>
                <strong className="d-block text-dark">₹1,000 Advance Token</strong>
                <span className="small text-muted">Lock room with small advance; balance at check-in</span>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div className="p-3 bg-white rounded-4 shadow-sm border d-flex align-items-center gap-3 h-100">
              <div className="bg-primary bg-opacity-10 text-primary p-3 rounded-circle fs-4 flex-shrink-0">
                <FaCheckCircle />
              </div>
              <div>
                <strong className="d-block text-dark">Free Cancellation</strong>
                <span className="small text-muted">
                  <Link to="/cancellation-refund-policy" className="text-decoration-underline text-danger fw-semibold">
                    100% refund up to 7 days prior →
                  </Link>
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Filter Buttons */}
        <div className="d-flex justify-content-center gap-2 mb-5 flex-wrap">
          <button
            className={`btn rounded-pill px-4 py-2 fw-semibold shadow-sm ${activeFilter === "all" ? "btn-danger" : "btn-light border text-dark"
              }`}
            onClick={() => setActiveFilter("all")}
          >
            All Rooms ({roomsList.length})
          </button>
          <button
            className={`btn rounded-pill px-4 py-2 fw-semibold shadow-sm ${activeFilter === "ac" ? "btn-danger" : "btn-light border text-dark"
              }`}
            onClick={() => setActiveFilter("ac")}
          >
            ❄️ AC Deluxe Rooms
          </button>
          <button
            className={`btn rounded-pill px-4 py-2 fw-semibold shadow-sm ${activeFilter === "family" ? "btn-danger" : "btn-light border text-dark"
              }`}
            onClick={() => setActiveFilter("family")}
          >
            👨‍👩‍👧‍👦 Family Suites (4+ Guests)
          </button>
          <button
            className={`btn rounded-pill px-4 py-2 fw-semibold shadow-sm ${activeFilter === "non-ac" ? "btn-danger" : "btn-light border text-dark"
              }`}
            onClick={() => setActiveFilter("non-ac")}
          >
            🍃 Budget Non-AC
          </button>
        </div>

        {/* Rooms Detailed Cards */}
        <div className="row g-4">
          {filteredRooms.map((room) => (
            <div className="col-12 col-lg-6" key={room.id}>
              <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden bg-white d-flex flex-column transition-all hover-shadow">
                <div className="position-relative">
                  <img
                    src={room.image}
                    alt={room.title}
                    className="card-img-top"
                    style={{ height: "270px", objectFit: "cover" }}
                    loading="lazy"
                  />
                  <span className="position-absolute top-0 start-0 m-3 badge bg-dark bg-opacity-80 px-3 py-2 rounded-pill small fw-semibold">
                    {room.badge}
                  </span>
                  <div
                    className="position-absolute bottom-0 end-0 m-3 p-2 px-3 rounded-pill text-white fw-bold shadow-lg"
                    style={{ background: "linear-gradient(135deg, #ff4757, #ff6b6b)" }}
                  >
                    ₹{room.price.toLocaleString("en-IN")} <span className="small fw-normal">/ night</span>
                  </div>
                </div>

                <div className="card-body p-4 d-flex flex-column flex-grow-1">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h2 className="h4 fw-bold text-dark mb-0 font-heading">{room.title}</h2>
                  </div>

                  <p className="text-secondary small mb-3">{room.desc}</p>

                  {/* Key specs */}
                  <div className="row g-2 mb-3 small bg-light p-3 rounded-3 border">
                    <div className="col-6 d-flex align-items-center gap-2">
                      <FaUserFriends className="text-danger flex-shrink-0" />
                      <span><strong>Max:</strong> {room.maxGuests} Guests</span>
                    </div>
                    <div className="col-6 d-flex align-items-center gap-2">
                      <FaBed className="text-danger flex-shrink-0" />
                      <span><strong>Bed:</strong> {room.bed}</span>
                    </div>
                    <div className="col-6 d-flex align-items-center gap-2">
                      <FaDoorOpen className="text-danger flex-shrink-0" />
                      <span><strong>Size:</strong> {room.size}</span>
                    </div>
                    <div className="col-6 d-flex align-items-center gap-2">
                      <FaWifi className="text-danger flex-shrink-0" />
                      <span><strong>Wi-Fi:</strong> High-Speed Free</span>
                    </div>
                  </div>

                  {/* Amenities List */}
                  <h6 className="fw-bold small text-dark mb-2">Room Amenities & Features:</h6>
                  <ul className="list-unstyled small text-secondary mb-4 row g-2">
                    {room.amenities.map((amenity, i) => (
                      <li key={i} className="col-12 col-sm-6 d-flex align-items-center gap-2">
                        <FaCheckCircle className="text-success small flex-shrink-0" />
                        <span>{amenity}</span>
                      </li>
                    ))}
                  </ul>

                  {/* Actions */}
                  <div className="mt-auto d-flex gap-2 pt-3 border-top">
                    <Link
                      to={`/images/${room.id}`}
                      className="btn btn-outline-secondary rounded-pill px-3 py-2 small fw-semibold flex-fill d-flex align-items-center justify-content-center gap-1"
                    >
                      <FaImage /> View Photos
                    </Link>
                    <Link
                      to={`/booking?room=${encodeURIComponent(room.title)}`}
                      className="btn btn-danger rounded-pill px-4 py-2 small fw-semibold flex-fill d-flex align-items-center justify-content-center gap-1 shadow-sm"
                    >
                      <FaCalendarAlt /> Book Room
                    </Link>
                    <a
                      href={`https://wa.me/${cleanPhone}?text=${encodeURIComponent(`Hi Ganesh Holiday Homes, I want to inquire about availability for ${room.title}`)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-outline-success rounded-circle p-2 d-flex align-items-center justify-content-center"
                      style={{ width: "40px", height: "40px" }}
                      title="Inquire on WhatsApp"
                    >
                      <FaWhatsapp />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Accommodation Property Notice */}
        <div className="mt-5 p-4 p-md-5 rounded-4 bg-white border shadow-sm text-center">
          <h3 className="h4 fw-bold text-dark mb-2 font-heading">Transparent Pricing & Direct Property Booking</h3>
          <p className="text-secondary small mb-3 mx-auto" style={{ maxWidth: "700px" }}>
            All rates listed on this page are quoted in <strong>Indian Rupees (₹ INR)</strong>. Room rates cover short-term guest accommodation at <strong>{hotelName}</strong> in Shrivardhan, Maharashtra. All reservations are made directly with the property management.
          </p>
          <div className="d-flex justify-content-center gap-2 flex-wrap">
            <a href={`tel:${cleanPhone}`} className="btn btn-outline-dark rounded-pill px-4 py-2 small fw-semibold">
              <FaPhoneAlt className="text-danger me-1" /> Call Front Desk: {hotelPhone}
            </a>
            <Link to="/booking" className="btn btn-danger rounded-pill px-4 py-2 small fw-semibold shadow-sm">
              <FaCalendarAlt className="me-1" /> Reserve Room Online
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default RoomsPage;
